import type { FC } from 'react';
import React from 'react';
import { getAppTitle, getTextThemeProvider } from 'venn-ui-kit';
import { Copyright, Markdown } from 'venn-components';
import { browserTest } from 'venn-utils';
import { cn } from '@/lib/utils';

const isBrowserSupported = browserTest();

const AuthenticationFooterAttribution: FC<React.PropsWithChildren & React.HTMLAttributes<HTMLDivElement>> = ({
  className,
}) => {
  const DISCLAIMER = `${getTextThemeProvider().appTitleFullName.toUpperCase()} IS FOR INSTITUTIONAL/WHOLESALE/PROFESSIONAL CLIENTS AND OTHER QUALIFIED CLIENTS IN CERTAIN JURISDICTIONS ONLY – NOT FOR RETAIL USE OR DISTRIBUTION.   FOR UK SUBSCRIBERS: ${getAppTitle().toUpperCase()} IS INTENDED ONLY FOR INVESTMENT PROFESSIONALS WITHIN THE MEANING OF ARTICLE 19 OF THE FINANCIAL SERVICES AND MARKETS ACT 2000 (FINANCIAL PROMOTION) ORDER 2005 (“FPO”) OR HIGH NET WORTH ENTITIES OR OTHER ENTITIES FALLING WITHIN ARTICLE 49 OF THE FPO.  FOR HK SUBSCRIBERS: Certain ${getAppTitle()} Pro features (including optimization) are not generally available in Hong Kong. ${getTextThemeProvider().operatorShortName} is based in the United States. ${getTextThemeProvider().operatorShortName} does not conduct any regulated activity (as defined in the Securities and Futures Ordinance (Cap. 571, Laws of Hong Kong)) in Hong Kong, and ${getTextThemeProvider().operatorShortName} is not licensed by any regulatory authority in Hong Kong.  FOR ERISA, PUBLIC PENSION AND OTHER RETIREMENT ASSET SUBSCRIBERS: ${getAppTitle()} is not for use as a primary basis for investment decisions. ${getTextThemeProvider().operatorShortName} does not hold itself out as a fiduciary (or as otherwise owing any other special duties) to any pension or retirement plan under pension, retirement or similar laws or regulations.`;
  return (
    <div
      className={cn([
        'text-venn-white text-[12px] leading-[16px] [&_a]:font-bold [&_a]:text-venn-primary-main [&_a]:border-0',
        '[&_a]:hover:border-b [&_a]:hover:border-solid [&_a]:hover:border-b-venn-primary-main',
        '[&_img]:h-2 [&_img]:inline-block [&_img]:m-0 [&_img]:mr-0.5',
        isBrowserSupported ? 'mb-0' : 'mb-[60px]',
        className,
      ])}
    >
      <Copyright lineBreak className="m-0 mb-2.5" />
      <div className="m-0 mb-2.5">
        <Markdown children={DISCLAIMER} />
      </div>
    </div>
  );
};

export default AuthenticationFooterAttribution;
